import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';
import { useOptionalHouseholdChatContext } from '@/modules/household/chat/contexts/householdChat.context';

/**
 * True when the user can use Artifact Studio in this household: the
 * `diagram_builder` flag is on, the user can edit household data, and the
 * household chat is available for the diagram editor.
 */
export function useIsArtifactStudioAvailable() {
  const enabled = useFeatureFlag('diagram_builder');
  const canEdit = useCanEditHouseholdData({ returnFalseOnMissingUser: true });
  const chat = useOptionalHouseholdChatContext();
  return enabled && canEdit && Boolean(chat);
}
